import { gray } from "./sitecolors"

export const lblattrs         = 'col-sm-3 col-md-3 col-lg-3 control-label'
export const lblattrs2         = 'col-sm-2 col-md-2 col-lg-2 control-label'
export const lblattrs3        = 'col-sm-3 col-md-3 col-lg-3 control-label'
export const lblattrsmed      = 'col-sm-2 col-md-4 col-lg-4 control-label'
export const inputattrxsmall  =  'col-sm-4 col-md-4 col-lg-4'
export const inputattrxxsmall =  'col-sm-2 col-md-2 col-lg-2'
export const inputattr3       =  'col-sm-3 col-md-3 col-lg-3'
export const lblattrsWide     = 'col-sm-3 col-md-4 col-lg-4 control-label'
export const lblattrs6        = 'col-sm-6 col-md-6 col-lg-6 control-label'
export const lblattrs7        = 'col-sm-7 col-md-7 col-lg-7 control-label'
export const lblattrs8        = 'col-sm-8 col-md-8 col-lg-8 control-label'
export const lblattrs9        = 'col-sm-9 col-md-9 col-lg-9 control-label'
export const lblattrs10       = 'col-sm-10 col-md-10 col-lg-10 control-label'
export const lblattrs11       = 'col-sm-10 col-md-10 col-lg-10 control-label'
export const inputattrs       =  'col-sm-8 col-md-8 col-lg-9'
export const inputattrs6      =  'col-sm-6 col-md-6 col-lg-6'
export const inputattrs2      =  'col-sm-2 col-md-2 col-lg-2'
export const inputattrs1      =  'col-sm-1 col-md-1 col-lg-1'
export const inputattrsSmall  =  'col-sm-8 col-md-8 col-lg-8'
export const box  = { 
                       border:`1px solid ${ gray }`, 
                       padding:'15px' , 
                       marginRight:'0px', 
                       marginBottom:'15px' 
                       
                    }
export const smallinput = { maxWidth:'40px',minHeight:'37px', marginLeft:'3px',textAlign:'center', borderRadius:'4px', borderColor:gray, borderWidth:'1px' }


export const oilfieldoptions = {
    blocks: [1,2], 
    delimiters: ['.'], 
    uppercase:true,
    numericOnly:true
} 



// WEBPACK FOOTER //
// ./src/utils/constants/style.js